<template>
  <div class="row iframe-container my-4">
    <div class="col-10 mx-auto" v-if="meeting">
      <h5 class="mb-2">
        {{ meeting.title }} by
        <router-link v-if="meeting.speaker" :to="'/speaker/' + meeting.speaker.url_key">{{ meeting.speaker.name }}</router-link>
        <span class="badge badge-danger ml-auto">Live</span>
      </h5>
      <p class="mb-2">
        {{ meeting.content }}
      </p>

      <div class="row" v-if="meeting.in_progress">
        <div class="col-12 col-xl-10">
          <div class="alert alert-info p-3 mt-4" v-if="showSignIn">
            <h5>You need to be signed in to view live streams.</h5>
            <button @click="$store.dispatch('auth/showModal')" class="btn btn-primary mt-2">Sign in</button>
          </div>
          <div v-else>
            <div v-if="meeting.type === 'meeting'">
              <vue-aspect-ratio v-if="isZoomSDKSupported" ar="16:9">
                <iframe :src="getMeetingURL()" frameborder="0" class="h-100 w-100"></iframe>
              </vue-aspect-ratio>
              <ZoomLink v-else :zoom_url="meeting.join_url" :passcode="meeting.zoom_meeting.password" />
            </div>
            <vue-aspect-ratio v-else ar="16:9">
              <StreamPlayer :src="getMeetingURL()" />
            </vue-aspect-ratio>
          </div>
        </div>
      </div>
      <div v-if="!meeting.in_progress" class="my-5">
        <div class="mb-5 text-center row">
          <div class="col-12 col-md-8 col-xl-6 offset-xl-3 offset-lg-2 d-flex justify-content-center">
            <b-img :src="meeting.attachment.url" fluid alt="Meeting Image" v-if="meeting.attachment" />
            <div v-else>
              <LiveThumbnail :video="meeting" />
            </div>
          </div>
        </div>
        <MeetingCountDown :start="meeting.start" :duration="meeting.duration" />
      </div>
    </div>
  </div>
</template>
<script>
import VueAspectRatio from 'vue-aspect-ratio';
import MeetingCountDown from './MeetingCountDown';
import ZoomLink from './ZoomLink';
import StreamPlayer from './StreamPlayer';
import LiveThumbnail from './LiveThumbnail';

export default {
  props: ['meetingType'],
  components: {
    MeetingCountDown: MeetingCountDown,
    'vue-aspect-ratio': VueAspectRatio,
    StreamPlayer,
    ZoomLink,
    LiveThumbnail,
  },
  mounted() {
    let url = '/api/live/' + this.meeting_id;
    if (this.occurrence) url += '?occurrence=' + this.occurrence;
    this.$http.get(url).then(resp => {
      this.meeting = resp.data;

      if (this.meeting.in_progress && this.meeting.login_required && !this.$store.getters['auth/isLoggedIn']) {
        this.$store.dispatch('auth/showModal');
      }
    });

    if (!this.isZoomSDKSupported) {
      let paddingTop = '15%';
      if (document.body.clientWidth < 700) {
        paddingTop = '25%';
      }
      if (document.body.clientWidth < 500) {
        paddingTop = '35%';
      }
      if (document.body.clientWidth < 400) {
        paddingTop = '55%';
      }
      document.querySelector('.vue-aspect-ratio .vue-aspect-ratio__inner').style.paddingTop = paddingTop;
    }
  },
  methods: {
    getWebinarURL() {
      return 'https://live.shasilluminated.org/hls/' + this.meeting.live_stream_key + '.m3u8';
    },
    getStreamURL() {
      return 'https://live.shasilluminated.org/hls/' + this.meeting.creator.stream_key + '.m3u8';
    },
    getMeetingURL() {
      if (this.meeting.type === 'stream') {
        return this.getStreamURL();
      } else if (this.meeting.type === 'webinar') {
        return this.getWebinarURL();
      }

      let name = '';
      let email = '';

      console.log(this.$store.getters['auth/user']);

      if (this.meeting.login_required) {
        if (!this.$store.getters['auth/isLoggedIn']) {
          return '';
        }
        name = this.$store.getters['auth/user'].fullname;
        email = this.$store.getters['auth/user'].email;
      } else {
        name = this.$store.getters['auth/isLoggedIn'] ? this.$store.getters['auth/user'].fullname : prompt('Please enter your name.');
        email = this.$store.getters['auth/isLoggedIn'] ? this.$store.getters['auth/user'].email : '';
      }
      return '/live-frame/' + this.meeting_id + '/watch?name=' + encodeURI(name) + '&email=' + encodeURI(email);
    },
    checkIfSafari() {
      let ua = navigator.userAgent.toLowerCase();
      if (ua.indexOf('safari') !== -1 && ua.indexOf('chrome') <= -1) {
        return true;
      }
    },
    checkIfMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
  },
  data() {
    return {
      meeting_id: this.$route.params.id,
      occurrence: this.$route.query.occurrence,
      meeting: null,
    };
  },
  computed: {
    isZoomSDKSupported() {
      return !this.checkIfSafari() && !this.checkIfMobile();
    },
    shouldAskForName() {
      return this.meeting.in_progress && !this.meeting.login_required && !this.$store.getters['auth/isLoggedIn'] && this.meeting.type === 'meeting';
    },
    showSignIn() {
      if (this.meeting && this.meeting.login_required) {
        return !this.$store.getters['auth/isLoggedIn'];
      }
      return false;
    },
  },
};
</script>
<style scoped>
.iframe-container {
  width: 100%;
}
</style>
